import { SchedulerPro } from '@bryntum/schedulerpro';
import { SchedulingContext } from '@koppla-tech/scheduling-engine';

import { useUserStore } from '@/services/store/user/store';

import {
  LocalProjectChangeEvent,
  LocalProjectChangeEventTemplate,
  RemoteProjectChangeEvent,
} from '../realTimeCollaboration/types';

export function getCurrentSchedulingContext(): SchedulingContext {
  const userStore = useUserStore();

  if (!userStore.ownUser) {
    throw new Error('Tried to call schedule function with undefined user id');
  }

  return {
    user: { id: userStore.ownUser.id },
  };
}

export function getSchedulingContextFromEvent(
  event: LocalProjectChangeEvent | LocalProjectChangeEventTemplate | RemoteProjectChangeEvent,
): SchedulingContext {
  if ('user' in event) {
    if (!event.user) {
      throw new Error('Tried to call schedule function with undefined user id');
    }
    return {
      user: { id: event.user.id },
    };
  }
  return getCurrentSchedulingContext();
}

export function isDateInViewport(scheduler: SchedulerPro, date: Date): boolean {
  if (!scheduler.visibleDateRange.startDate || !scheduler.visibleDateRange.endDate) return false;

  const viewportStart = new Date(scheduler.visibleDateRange.startDate);
  const viewportEnd = new Date(scheduler.visibleDateRange.endDate);

  return date > viewportStart && date < viewportEnd;
}

export function isResourceInViewport(
  scheduler: SchedulerPro,
  sortedResourceIds: string[],
  resourceId: string,
): boolean {
  const resourceIndex = sortedResourceIds.indexOf(resourceId);
  if (resourceIndex === -1) return false;

  const firstVisibleResourceId = scheduler.visibleResources.first?.id.toString() ?? '';
  const lastVisibleResourceId = scheduler.visibleResources.last?.id.toString() ?? '';

  const firstVisibleIndex = sortedResourceIds.indexOf(firstVisibleResourceId);
  const lastVisibleIndex = sortedResourceIds.indexOf(lastVisibleResourceId);

  return resourceIndex >= firstVisibleIndex && resourceIndex <= lastVisibleIndex;
}
